import * as utils from '@core/utils';
import * as Events from '@core/events';

import { TSchema } from '@core';
import { extractTargetString } from '@core/utils/common';

const hasTemplateString = (value: string) => {
  return /\$\{(.*)\}.*/g.test(value);
};

export const handler = ({
  form,
}: Pick<Events.TEventInformation<unknown>, 'form'>) => {
  const replaceTemplateString = (targetString: string): any => {
    const scopedString = extractTargetString<string>(
      targetString,
      form.scope,
      form.scope,
    );
    return replaceTemplateString(scopedString);
  };

  const inObject = <T extends Record<string, unknown>>(
    obj: T,
    recursionLevel = 0,
  ): Record<string, unknown> => {
    if (typeof obj === 'string') {
      return replaceTemplateString(obj);
    }
    if (typeof obj === 'number') {
      return obj;
    }

    const object = { ...obj };
    return Object.keys(object).reduce((acc, key): Record<string, string> => {
      if (object[key] === null) {
        return acc;
      }

      if (Array.isArray(object[key])) {
        return {
          ...acc,
          [key]: (object[key] as unknown[]).map(inObject),
        } as Record<string, string>;
      }

      if (typeof object[key] === 'object') {
        return {
          ...acc,
          [key]: {
            ...inObject(
              { ...(object[key] as Record<string, unknown>) },
              recursionLevel + 1,
            ),
          },
        } as Record<string, string>;
      }

      if (typeof object[key] !== 'string') {
        return {
          ...acc,
          [key]: object[key],
        } as Record<string, string>;
      }

      if (!hasTemplateString(object[key] as string)) {
        return { ...acc, [key]: object[key] } as Record<string, string>;
      }
      let value = replaceTemplateString(object[key] as string);

      try {
        if (utils.string.hasJsonStructure(value)) {
          value = JSON.parse(value);
        }
        // eslint-disable-next-line no-empty
      } catch (e) {}

      return {
        ...acc,
        [key]: value,
      } as Record<string, string>;
    }, {} as Record<string, string>);
  };

  form.scopedSchema = {
    ...form.schema,
    ...inObject({
      visibilityConditions: form?.schema?.visibilityConditions,
    } as Partial<TSchema>),
  };
};
